export default __webpack_public_path__ + "static/media/united kingdom.7c8e24ac.png";